import { Injectable, inject } from '@angular/core';
import { CoreActions } from '@next/core-lib';
import { LocaleService } from '@next/core-lib/i18n';
import { NotificationActions } from '@next/core-lib/notification';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, finalize, map, mergeMap, startWith } from 'rxjs/operators';

import { Cow, FertilityState, FertilitySummary } from '../../models/fertility.model';
import { FertilityReportService } from '../../services/fertility-report.service';
import * as FertilityActions from '../actions/fertility-actions';

@Injectable()
export class FertilityEffects {
  private readonly actions$ = inject(Actions);
  private readonly fertilityReportService = inject(FertilityReportService);
  private readonly localeService = inject(LocaleService);
  private readonly store = inject<Store<FertilityState>>(Store);

  protected getCowsByDate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FertilityActions.loadCowsByDateRequest),
      mergeMap(({ date }) =>
        this.fertilityReportService.getCows(date).pipe(
          map((cows: Cow[]) => FertilityActions.loadCowsByDateSuccess({ date, cows })),
          catchError((errorResponse) => {
            const message = errorResponse.error?.message
              ? this.localeService.translate(errorResponse.error.message)
              : errorResponse.message;
            return of(NotificationActions.errorSnackbar({ message }));
          }),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
        ),
      ),
    ),
  );
  protected getFertilitySummaryByDate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FertilityActions.loadFertilitySummaryRequest),
      mergeMap(({ date }) =>
        this.fertilityReportService.getSummary(date).pipe(
          map((fertilitySummary: FertilitySummary) =>
            FertilityActions.loadFertilitySummarySucces({ date, fertilitySummary }),
          ),
          catchError((errorResponse) => {
            const message = errorResponse.error?.message
              ? this.localeService.translate(errorResponse.error.message)
              : errorResponse.message;
            return of(NotificationActions.errorSnackbar({ message }));
          }),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
        ),
      ),
    ),
  );
}
